import script from "./AssetDetailAssessmentProgramsLinkAddition.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetDetailAssessmentProgramsLinkAddition.vue?vue&type=script&setup=true&lang=ts"

import "./AssetDetailAssessmentProgramsLinkAddition.vue?vue&type=style&index=0&id=192c1b0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-192c1b0a"]])

export default __exports__